export default __webpack_public_path__ + "static/media/merge_gradient.6b93bf85.svg";